import { Subject } from 'rxjs';

const serpViewAllDataSubject = new Subject();

export const updateSerpViewAllDataSubject = {
  update: message => serpViewAllDataSubject.next(message),
  clear: () => serpViewAllDataSubject.next(),
  get: () => serpViewAllDataSubject.asObservable()
};
